import React from 'react';
import { styled, keyframes } from '@mui/material/styles';
import { Box } from '@mui/material';

const wave = keyframes`
  0% {
    background-position: 200% center;
  }
  100% {
    background-position: -200% center;
  }
`;

const WaveTextContainer = styled(Box)(({ theme }) => ({
  display: 'inline-block',
  background: `linear-gradient(
    90deg,
    ${theme.palette.text.secondary} 0%,
    ${theme.palette.text.secondary} 30%,
    ${theme.palette.text.primary} 50%,
    ${theme.palette.text.secondary} 70%,
    ${theme.palette.text.secondary} 100%
  )`,
  backgroundSize: '200% 100%',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  color: 'transparent',
  WebkitTextFillColor: 'transparent',
  animation: `${wave} 3s linear infinite`,
  '& *': {
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    color: 'transparent',
    WebkitTextFillColor: 'transparent',
  },
}));

interface WaveTextProps {
  children: React.ReactNode;
  sx?: any;
}

const WaveText: React.FC<WaveTextProps> = ({ children, sx }) => {
  return (
    <WaveTextContainer sx={sx}>
      {children}
    </WaveTextContainer>
  );
};

export default WaveText;
